import { render } from "./Password.vue?vue&type=template&id=6fd1e489&scoped=true&ts=true"
import script from "./Password.vue?vue&type=script&lang=ts"
export * from "./Password.vue?vue&type=script&lang=ts"

import "./Password.vue?vue&type=style&index=0&id=6fd1e489&lang=scss&scoped=true"
import "./Password.vue?vue&type=style&index=1&id=6fd1e489&lang=postcss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd1e489"]])

export default __exports__